import axios from 'axios';
import { createRotatedImageBlob } from './image_util';

/** Sends a HEAD request to the url, returning true only if it is a 200 */
export async function checkResource(url: string) {
  try {
    const resp = await axios.head(url);
    return resp.status === 200;
  } catch (error) {
    return false;
  }
}

/** Fetches a url as a blob */
export async function fetchPhotoBlob(src: string) {
  const resp = await axios.get<Blob>(src, { responseType: 'blob' });
  return resp.data;
}

/** Fetches an image as a blob, then applies it to an HTMLImage */
export async function loadBlobAsImage(src: string, rotation?: number) {
  return new Promise<HTMLImageElement>(async (res, rej) => {
    const blob = await fetchPhotoBlob(src);
    let blobSrc;

    if (rotation) {
      const rotatedBlob = await createRotatedImageBlob(blob, rotation);
      blobSrc = URL.createObjectURL(rotatedBlob);
    } else {
      blobSrc = URL.createObjectURL(blob);
    }

    const image = new Image();

    image.addEventListener('load', () => {
      res(image);
    });

    image.addEventListener('error', () => {
      rej();
    });

    image.src = blobSrc;
  });
}
